import { render } from "./Announcement.vue?vue&type=template&id=374e5015&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"

import "./Announcement.vue?vue&type=style&index=0&id=374e5015&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-374e5015"

export default script